<div class="popup">
  <div class="modal-header">
    <div class="mat-dialog-title" translate>Reset Your Password</div>
  </div>
  <div style="padding:10px;margin-bottom:70px;">
    <div>
      Students are not allowed to change their passwords.
    </div>
    <div style="padding-top:15px;">
      Please contact your school for assistance.
    </div>
  </div>
  <div class="sis-app-footer">
    <tyl-button image="close.png" label="Close" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</div>
